import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { ComponentStatus, StateComponent } from '../../../../../common/components/state/state.component';
import { CompetitionGroupCommonService } from '../common/services/competition-group-common.service';
import { IStandingModel } from '../../../../../common/apis/tournament/model/tournament.model';
import { ActivatedRoute } from '@angular/router';
import { AnalyticsService } from '../../../../../common/services/analytics.service';
import { CompetitionGroupApiService } from '../../../../../common/apis/competition-group/competition-group-api.service';
import { ICompetitionGroupModel } from '../../../../../common/apis/competition-group/model/competitoin-group.model';
import { MatList, MatListItem, MatListItemAvatar, MatListItemTitle } from '@angular/material/list';
import { NgOptimizedImage } from '@angular/common';
import { MatCard, MatCardContent } from '@angular/material/card';
import { ListHeaderComponent } from '../../../../../common/components/list-header/list-header.component';
import { LoadingContainerComponent } from '../../../../../common/components/loading-container/loading-container.component';

@Component({
  selector: 'oo-standings',
  templateUrl: './standings.component.html',
  styleUrls: ['./standings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LoadingContainerComponent, ListHeaderComponent, MatCard, MatCardContent, MatList, MatListItem, NgOptimizedImage, MatListItemAvatar, MatListItemTitle],
})
export class StandingsComponent extends StateComponent<StandingsComponentState> implements OnInit {

  private readonly compGroupApi = inject(CompetitionGroupApiService);
  private readonly route = inject(ActivatedRoute);
  private readonly tournamentCommonService = inject(CompetitionGroupCommonService);
  state: StandingsComponentState = {
    status: 'ready',
    compGroup: this.tournamentCommonService.getCompGroupInfo(this.route.snapshot.parent!.paramMap.get('compGroupId')!),
    standings: [],
  };
  private readonly analyticsService = inject(AnalyticsService);

  ngOnInit(): void {
    this.analyticsService.trackScreenName('standings');
    this.fetchData();
  }

  private fetchData(): void {
    this.updateStatus('loading');
    this.compGroupApi.getCompGroupStandings(this.state.compGroup.id)
      .then((standings) => {
        this.updateState({
            status: 'ready',
            standings: standings.sort((a, b) => a.score > b.score ? -1 : 1),
          },
        );
      })
      .catch((e: Error) => {
        console.error(e);
        this.updateStatus('error');
      });
  }
}

interface StandingsComponentState {
  status: ComponentStatus;
  compGroup: ICompetitionGroupModel;
  standings: IStandingModel[];
}
